import './style.sass';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

export type ListStagesType = {
    number: number;
    text: string;
};
type LayoutPagePropsTye = {
    listStages: ListStagesType[];
};
const LayoutPage = ({ listStages }: LayoutPagePropsTye) => {
    return (
        <div className="ck10-layout-page">
            <FullWrapper className="ck10-layout-pageCase">
                <div className="ck10-layout-pageWrapper">
                    <div className="ck10-layout-pageListParagraf">
                        <div className="ck10-layout-pageParagraf">
                            К&nbsp;нам обратился клиент с&nbsp;типичной проблемой: бюджет тратится
                            впустую, результат непонятен, лидов с&nbsp;рекламы крайне мало.
                            На&nbsp;момент обращения у&nbsp;застройщика было 5&nbsp;объектов
                            строительства. Потом добавилось еще 2&nbsp;жилых комплекса.
                        </div>
                    </div>
                    <div className="ck10-layout-pageBottom">Задача</div>
                    {listStages.map((item, index) => (
                        <div key={index} className="ck10-layout-pageList">
                            <div className="ck10-layout-pageListNumber">{item.number}</div>
                            <div
                                dangerouslySetInnerHTML={{ __html: item.text }}
                                className="ck10-layout-pageListText"
                            />
                        </div>
                    ))}
                </div>
            </FullWrapper>
        </div>
    );
};

export default LayoutPage;
